export default {
  heavySignsOfUse: {
    id: 'outlet_product_heavy_signs_of_use',
    defaultMessage: 'Heavy signs of use',
  },
  priceNew: {
    id: 'outlet_price_new',
    defaultMessage: '{price, html} new',
  },
}
